import { render, staticRenderFns } from "./channelOrder.vue?vue&type=template&id=173cd763&scoped=true"
import script from "./channelOrder.vue?vue&type=script&lang=js"
export * from "./channelOrder.vue?vue&type=script&lang=js"
import style0 from "./channelOrder.vue?vue&type=style&index=0&id=173cd763&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173cd763",
  null
  
)

export default component.exports